export default "__VITE_ASSET__C4ATrA9k__"